import React, { useEffect, useState } from 'react';

export default function CreateLinkedNoteModal({
  open = false,
  initialTitle = '',
  hasParentTags = false,
  onConfirm,
  onCancel,
  busy = false,
}) {
  const [title, setTitle] = useState('');
  const [inheritTags, setInheritTags] = useState(false);

  useEffect(() => {
    if (!open) return;
    setTitle(String(initialTitle || '').trim());
    setInheritTags(Boolean(hasParentTags));
  }, [open, initialTitle, hasParentTags]);

  if (!open) return null;

  const canCreate = Boolean(String(title || '').trim()) && !busy;

  return (
    <div className="action-confirm-overlay" style={{ zIndex: 1201 }} onMouseDown={onCancel}>
      <div className="action-confirm-modal" onMouseDown={(e) => e.stopPropagation()}>
        <h3 className="action-confirm-title">Create Linked Note</h3>
        <p
          className="action-confirm-message"
          style={{ marginTop: '2px', marginBottom: '8px', fontSize: '0.82rem', textAlign: 'center' }}
        >
          Saves this note, creates a new linked note, and opens it.
        </p>
        <input
          className="search-input"
          value={title}
          onChange={(e) => setTitle(e.target.value)}
          placeholder="New note title"
          autoFocus
          style={{ width: '100%', boxSizing: 'border-box', marginBottom: '10px' }}
          onKeyDown={(e) => {
            if (e.key === 'Enter' && canCreate) onConfirm?.(String(title || '').trim(), inheritTags);
            if (e.key === 'Escape') onCancel?.();
          }}
        />
        <label
          style={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            gap: '8px',
            marginBottom: '10px',
            opacity: hasParentTags ? 1 : 0.5,
            cursor: hasParentTags ? 'pointer' : 'not-allowed',
            userSelect: 'none',
            fontSize: '0.82rem',
            textAlign: 'center',
          }}
        >
          <input
            type="checkbox"
            checked={inheritTags}
            disabled={!hasParentTags || busy}
            onChange={(e) => setInheritTags(e.target.checked)}
          />
          <span>Inherit tags from parent note</span>
        </label>
        <div className="action-confirm-actions">
          <button className="btn-subtle" onClick={onCancel} disabled={busy}>Cancel</button>
          <button className="btn-subtle" onClick={() => onConfirm?.(String(title || '').trim(), inheritTags)} disabled={!canCreate}>
            {busy ? 'Creating...' : 'Create & Open'}
          </button>
        </div>
      </div>
    </div>
  );
}
